import React, { useEffect } from 'react';
import { trans } from '@spotahome/soyuz/client';
import PropTypes from 'prop-types';
import { Button } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import './NoMatches.scss';

const NoMatches = ({ goToFilters }) => {
  useEffect(() => {
    Metrics.ga.sendEvent('Matcher', 'NoMatches', 'pageview');
  }, []);

  const handleGoToFilters = () => {
    Metrics.ga.sendEvent('Matcher', 'go to filters', 'button click');
    goToFilters();
  };

  return (
    <div className={'matcher-nomatches'}>
      <h2 className={'matcher-nomatches--title'}>
        {trans('search.matcher.no-matches.title')}
      </h2>
      <p className={'matcher-nomatches--text'}>
        {trans('search.matcher.no-matches.text')}
      </p>
      <Button
        fullWidth
        className={'matcher-nomatches--button'}
        size="large"
        onClick={handleGoToFilters}
      >
        {trans('search.matcher.no-matches.button')}
      </Button>
    </div>
  );
};

NoMatches.propTypes = {
  goToFilters: PropTypes.func.isRequired
};

export default NoMatches;
